export { TemplateSettings } from "./TemplateSettings";



// WEBPACK FOOTER //
// ./src/features/director/pages/template-editor/components/template-settings/index.ts